import { useEffect } from 'react';
import { setSubProduct } from '@atlassian/jira-platform-router-utils/src/common/utils/index.tsx';
import { useSubProduct } from '@atlassian/jira-subproduct/src/index.tsx';

const SubProductUpdater = () => {
	const subProduct = useSubProduct();
	useEffect(() => {
		setSubProduct(subProduct);
	}, [subProduct]);

	return null;
};

export { SubProductUpdater };
